(function(){
'use strict';

angular.module('classy').constant('scDonationThemeDefaults', {
  type: 'donation',
  start: {
    date: new Date(),
    time: new Date()
  },
  styles: {
    headerLogo: null,
    primaryColor: 'rgba(66, 92, 205, 1)',
    footerBgColor: 'rgba(26,26,26,1)',
    background: {
      preset: 'adaptive',
      color: 'rgba(64, 72, 78, 1)',
      image: null,
      repeat: 'no-repeat',
      imageOpacity: 100,
      colorOpacity: 100,
      blur: 0,
      position: 'center center',
      size: 'initial',
      fixed: false
    },
    registerBtnText: 'Reserve',
    scss: null,
    css: null
  },
  pages: {
    /** Donation Page */
    donation: {
      background: {
        color: null,
        image: null,
        position: 'top center',
        size: 'cover',
        repeat: 'no-repeat',
        imageOpacity: 100,
        colorOpacity: 100,
        blur: 0
      },
      block_sections: [{
        blocks: ['header'],
        name: 'header',
        position: 'top'
      }, {
        blocks: ['donation'],
        name: 'body'
      }, {
        blocks: ['footer'],
        name: 'footer',
        position: 'bottom'
      }]
    },

    /** Thank You Page */
    'thank-you': {
      background: {
        color: null,
        image: null,
        position: 'top center',
        size: 'cover',
        repeat: 'no-repeat',
        imageOpacity: 100,
        colorOpacity: 100,
        blur: 0
      },
      block_sections: [{
        blocks: ['header'],
        name: 'header',
        position: 'top'
      }, {
        blocks: ['thank-you'],
        name: 'body'
      }, {
        blocks: ['footer'],
        name: 'footer',
        position: 'bottom'
      }]
    }
  }
});
})();